import React from "react";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  className?: string;
  parentClassName?: string;
}

export const LayoutContainer = (props: Props) => {
  return (
    <section className={props.parentClassName || ""}>
      <div className={`max-w-7xl mx-auto ${props.className || ""} px-3 lg:px-0`}>
        {props.children}
      </div>
    </section>
  );
};
